import { OBSERVERTYPES } from './../constants';
import { BaseModel } from './base.model';
import { Deserializable } from './deserializable';

export class ObserverModel extends BaseModel implements Deserializable {

  // columns
  firstname: string;
  lastname: string;
  email: string;
  type: string;
  directlink: string;
  country: string;
  timezone: string;
  role: string;
  tz_offset: string; // tslint:disable-line: variable-name
  hashed_id: any; // tslint:disable-line: variable-name
  invited_at: any; // tslint:disable-line: variable-name

  deserialize(input: any): this {
    Object.assign(this, input);
    if (input?.pivot) {
      this.hashed_id = input.pivot.hashed_id;
      this.invited_at = input.pivot.invited_at;
    }
    return this;
  }

  get fullname(): string {
    return this.firstname + ' ' + this.lastname;
  }

  get initials(): string {
    return (this.firstname && this.lastname) ? this.firstname[0] + this.lastname[0] : '-';
  }

  getTypename(): string {
    return (this.type) ? OBSERVERTYPES[this.type] : '';
  }

}
